/**
 * Meta-variant copy overrides.
 *
 * After the 2026-06-06 cleanup, this file holds a single item: the legal
 * disclaimer footer shown only on meta variants (meta-short, meta-advertorial).
 * All other copy now matches between organic and meta variants because:
 *   1. Meta SAC restrictions apply to ad creative review, not funnel landing
 *      pages. The funnel can use the same conversion-tested copy as organic.
 *   2. The previously-softened "87% improved labs" stat was removed entirely
 *      (it was fabricated). The later "Trusted by 17,000+ kidney patients" also
 *      went (2026-10-20): RC counts app customers, not verified patients. Now
 *      "40,000+ people" = RevenueCat lifetime customers (46,167 on 2026-10-19),
 *      rounded down for reinstalls.
 *
 * If we ever need to add channel-specific copy in the future, add new keys
 * here and gate them on `isMetaVariant()` in the consuming component.
 */

export const META_COPY = {
  legalDisclaimer:
    'KidneyPal is for informational purposes and is not a substitute for medical advice. Consult your nephrologist or dietitian before making dietary changes.',
}
